export enum CustomsPayorEnum {
    SENDER = 'SENDER',
    RECIPIENT = 'RECIPIENT',
    COLLECT = 'COLLECT',
    THIRD_PARTY = 'THIRD_PARTY',
    NOT_DUTIABLE = 'NOT_DUTIABLE'
}
